import { API_URL, buildHeaders, handleResponse } from './apiClient';

export const uploadFileShare = async (token, file, recipientIds) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('recipientIds', JSON.stringify(recipientIds));

  const response = await fetch(`${API_URL}/file-shares/upload`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  return handleResponse(response, 'Kunne ikke laste opp fil');
};

export const getReceivedFiles = async (token) => {
  const response = await fetch(`${API_URL}/file-shares/received`, {
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente mottatte filer');
};

export const getSentFiles = async (token) => {
  const response = await fetch(`${API_URL}/file-shares/sent`, {
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente sendte filer');
};

export const downloadFileShare = async (token, fileId) => {
  const response = await fetch(`${API_URL}/file-shares/${fileId}/download`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || 'Kunne ikke laste ned fil');
  }
  return response;
};

export const deleteFileShare = async (token, fileId) => {
  const response = await fetch(`${API_URL}/file-shares/${fileId}`, {
    method: 'DELETE',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke slette fil');
};

export const getPhoneDirectory = async (token) => {
  const response = await fetch(`${API_URL}/employees/phone-directory`, {
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke hente brukere');
};
